import React from "react";
import { NavLink, useParams } from "react-router-dom";

import { useOrder } from "hooks/orders";
import { useUnits } from "hooks/units";

import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Skeleton,
  Grid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";

const ViewKitOrder = () => {
  const { id } = useParams();
  const { isFetching: isLoading, data } = useOrder(id);
  const { units, type_kits } = useUnits()

  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      pt={{ sm: "120px", lg: "160px" }}
    >
      <Card w={{ md: "100%", lg: "50%" }}>
        <CardHeader mb="40px">
          <Flex direction="row" w="100%" justify="space-between">
            <Text
              color={textColor}
              fontSize="lg"
              fontWeight="bold"
              mb="3px"
            >
              Solicitação #{id}
            </Text>
            <NavLink to="/sistema/solicitacoes/kits">
              <Button >
                Voltar
              </Button>
            </NavLink>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Grid
              templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
              templateRows={{ md: "repeat(1, 1fr)" }}
              gap="24px"
              mb="24px"
            >
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Status
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data && data.status ? data.status.toUpperCase() : null}
                  </Text>
                </Skeleton>
              </FormControl>
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Unidade
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data?.partner_place?.name || null}
                  </Text>
                </Skeleton>
              </FormControl>
            </Grid>
            <Grid
              templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
              templateRows={{ md: "repeat(1, 1fr)" }}
              gap="24px"
            >
              {
                type_kits.map(tk => (
                  <FormControl >
                    <FormLabel
                      color={textColor}
                      fontWeight="bold"
                      fontSize="xs"
                    >
                      Quantidade {tk.name}
                    </FormLabel>
                    <Skeleton height={"25px"} isLoaded={!isLoading && data}>
                      <Text
                        color={textColor}
                        fontSize="lg"
                        fontWeight="bold"
                        mb="3px"
                      >
                        { data && data.kits && data.kits[`kit_type_${tk.id}`] ? data.kits[`kit_type_${tk.id}`] : null }
                      </Text>
                    </Skeleton>
                  </FormControl>
                ))
              }
            </Grid>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  )
}

export default ViewKitOrder